import { SlaCarrierT, SlaTariffT } from '../types/sla.types'

export const SlaTariffs: SlaTariffT[] = [
    { id: 1, name: 'Стандарт', api_key: 'standart' },
    { id: 2, name: 'Экспресс', api_key: 'express' },
]

export const SLA_CARRIERS: SlaCarrierT[] = [
    { id: 1135, name: 'Эйр Астана АО' },
    { id: 1249, name: 'ДХЛ ИНТЕРНЕШНЛ КАЗАХСТАН ТОО' },
    { id: 1902, name: 'Asia Freight ТОО' },
    { id: 2872, name: 'АО АВИАКОМПАНИЯ SCAT ТОО' },
]

export const SHIPMENT_TYPES = [
    { id: 1, name: 'Стандарт' },
    { id: 2, name: 'Экспресс' },
]
